import { Backdrop, Snackbar, Theme, Alert } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { FeedbackProps } from './FeedbackProvider';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      // https://material-ui.com/customization/z-index/#z-index
      zIndex: theme.zIndex.tooltip,
    },
  })
);

type Props = {
  feedbackIsVisible: boolean;
  message: FeedbackProps['message'];
  severity: FeedbackProps['severity'];
};

/**
 * @summary Всплывашка-фидбэк, которая показывает реакцию на действие пользователя.
 * Например, этим действием может быть нажатие на кнопку.
 *
 * @param feedbackIsVisible - Отобразить или скрыть всплывашку.
 * @param message - Сообщение для всплывашки.
 * @param severity - Тип фидбэка. Полностью повторяет свойство severity
 * у компонента [Alert]{@link https://material-ui.com/api/alert/#props} от material-ui.
 */
export const FeedbackComponent = ({ feedbackIsVisible, message, severity }: Props) => {
  const classes = useStyles();
  return (
    <Backdrop open={feedbackIsVisible} className={classes.backdrop}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={feedbackIsVisible}>
        <Alert severity={severity}>{message}</Alert>
      </Snackbar>
    </Backdrop>
  );
};
